export default function init() {
	let video = document.querySelector('[data-js-panel=video]');
	let youtube = document.querySelector('[data-js-panel=youtube]');
	if (video || youtube) {
		let panels = document.querySelector(
			'[data-modular-content-collection]'
		);
		import('./video-carousel' /* webpackChunkName: "panel-video" */)
			.then(mod => mod.default(panels))
			.then(() => console.info('Initialized video or youtube panel.'));
	}

	let tabs = document.querySelector('[data-js-panel=tabs]');
	if (tabs) {
		import('./tabs' /* webpackChunkName: "panel-tabs" */)
			.then(mod => mod.default())
			.then(() => console.info('Initialized tab panel.'));
	}

	let accordion = document.querySelector('[data-js-panel=accordion]');
	if (accordion) {
		import('./accordion' /* webpackChunkName: "panel-accordion" */)
			.then(mod => mod.default())
			.then(() => console.info('Initialized accordion panel'));
	}
}
